/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />

var materialId = 207;
var longSideId = 210;
var shortSideId = 211;
var widthId = 213;
var heightId = 214;

var customValueDefaultMin = 100;
var customValueDefaultMax = 10000;

var AttributeCustomValueModel = function (pageModelHndl, attributeModelHndl) {
    var that = this;

    that.lookUpAttributeId = materialId;

    that.CustomValueAttributeIds = [
        longSideId,
        shortSideId,
        widthId,
        heightId 
    ];

    that.IsCustomValueOptionAvailable = ko.computed(function () {
        return that.CustomValueAttributeIds.some(function (itemAttributeId) {
            var attributeId = getAttributeId();
            return attributeId === itemAttributeId;
        });
    });

    that.IsCustomValueOptionEnabled = ko.computed(function () {
        var productModel = getProductModel();
        var attribute = getAttributeById(productModel, materialId);

        if (!attribute) {
            return false;
        }
        return attribute.SelectedObjectValueId() || false;
    });

    that.keyDownCallback = function(data, event) {
        //When another key as the tab key was pressed or tab was pressed together with a modifier, we don't handle this -> OK
        if (event.keyCode !== "\t".charCodeAt(0) || event.shiftKey || event.altKey || event.ctrlKey) {
            return true;
        }
        var productModel = getProductModel();
        //When the ProductModel is already valid, some field below the product configuration should be visible and tab would set the focus to this field -> OK
        if (productModel.IsProductModelValid()) {
            return true;
        }
        var attributes = productModel.Attributes();
        var currentAttributeIndex = attributes.indexOf(attributeModelHndl);
        //There is at least one more attribute below the current one and the current one is already successfully validated, so that the field below is
        // displayed (default view mode) or the expert mode is selected (in which case the field below is always displayed), so tab would set the focus to this
        //field -> OK
        if (currentAttributeIndex < attributes.length - 1 && (attributes[currentAttributeIndex].IsValid() || pageModelHndl.pProductContentModeModel.IsExpertModeSelected())) {
            return true;
        }
        //We are either in the last attribute and the ProductModel is not yet valid or in an attribute before the last one but it is not yet valid
        //-> block the tab key (by returning false) and trigger a change event to validate the current attribute
        event.target.dispatchEvent(new Event('change'));
        return false;
    };

    var isDominantCustomValueAttribute = function (attributeId) {
        return attributeId === longSideId || attributeId === widthId;
    };

    var getDominantAttributeId = function () {
        var attributes = [
            longSideId,
            widthId
        ];

        var firstMatchingAttributeId = attributes.find(function (attributeId) {
            var productModel = getProductModel();
            return getAttributeById(productModel, attributeId) || false;
        });

        return firstMatchingAttributeId;
    };

    var isLessThanDominantAttributeValue = function (sourceValue) {
        var attributeId = getAttributeId();
        var dominantCustomValueAttribute = isDominantCustomValueAttribute(attributeId);
        if (dominantCustomValueAttribute) {
            // no validation required for dominant attribute.
            // we want to show the error on the non-dominant attribute
            return true;
        }

        var dominantAttributeId = getDominantAttributeId();
        if (!dominantAttributeId) {
            // no dominant attribute found, we good here
            return true;
        }

        console.info("found dominant attributeId ", dominantAttributeId);

        var productModel = getProductModel();
        var domninantAttribute = getAttributeById(productModel, dominantAttributeId);
        var dominantAttributeValue = domninantAttribute.CustomValue.CustomValue();
        return parseInt(sourceValue) <= parseInt(dominantAttributeValue);
    };
    
    var isInteger = function(value) {
        return value % 1 === 0;
    }

    that.clickSwitchValues = function() {
        var dominantAttributeId = getDominantAttributeId();
        if (!dominantAttributeId) {
            // no dominant attribute found, we good here
            return;
        }

        console.info("found dominant attributeId ", dominantAttributeId);

        var productModel = getProductModel();
        var domninantAttribute = getAttributeById(productModel, dominantAttributeId);
        var dominantAttributeValue = domninantAttribute.CustomValue.CustomValue();

        // switch values
        domninantAttribute.CustomValue.CustomValue(that.CustomValue());
        that.CustomValue(dominantAttributeValue);
    };

    that.IsCustomValueOptionSelected = ko.observable(false);
    that.CustomValueMin = ko.observable(customValueDefaultMin); // value in mm
    that.CustomValueMax = ko.observable(customValueDefaultMax); // value in mm
    that.CustomValue = ko.observable(0).extend({
        throttle: 500,
        required: true,
        min: that.CustomValueMin,
        max: that.CustomValueMax,

        validation: {
            validator: function (currentValue) {
                return isInteger(currentValue) && isLessThanDominantAttributeValue(currentValue);
            }
        }
    }); // value in mm

    that.HasErrorIsLessThanDominantAttributeValue = ko.computed(function() {
        return !isLessThanDominantAttributeValue(that.CustomValue());
    }, that);
    
    that.HasInvalidNumber = ko.computed(function() {
        return !isInteger(that.CustomValue());
    }, that);

    that.IsValid = ko.computed(function() {
        if (that.IsCustomValueOptionAvailable() && that.IsCustomValueOptionSelected()) {
            that.CustomValue.validate(that.CustomValue());
            if (!that.CustomValue.hasError()) {
                return true;
            }
        }
        return false;
    },
    that);

    that.CustomValueMinText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.CustomValueMin()) + "";
    });

    that.CustomValueMaxText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.CustomValueMax()) + "";
    });

    that.CustomValueCmText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { minimumFractionDigits: 1 }).format(that.CustomValue() / 10) + "";
    });

    that.IsCustomValueOptionSelected.subscribe(function (newValue) {
        if (newValue == "true") {
            console.log("set SelectedObjectValueId to null");
            that.SelectedObjectValueId(undefined);
        }
    });

    var pushCustomValue = function (newValue) {
        var productConfigurationFilterItem = new ProductConfigurationFilterItem(attributeModelHndl);
        console.log("pushing customValue ", productConfigurationFilterItem, " to stack");
        pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues.push(productConfigurationFilterItem);
    };

    that.CustomValue.subscribe(function (newValue) {
        that.IsCustomValueOptionSelected(true);

        pushCustomValue(newValue);
        pageModelHndl.pProductModel.UpdateProductModel();
    });

    var applyCustomValue = function (customValueProperty) {
        var attributeId = customValueProperty.AttributeId;
        var min = customValueProperty.Min;
        var max = customValueProperty.Max;

        var productModel = getProductModel();
        var attribute = getAttributeById(productModel, attributeId);
        if (!attribute) {
            console.info("found customValue but didnt find matching attribute with id ",
                attributeId);
            return;
        }

        attribute.CustomValue.CustomValueMin(min);
        attribute.CustomValue.CustomValueMax(max);

        console.log("applied customValue to attributeId ", attributeId, "min ", min, "max ", max);
    };

    that.applyCustomValues = function (customValueProperties) {
        for (var i = 0; i < customValueProperties.length; i++) {
            var customValueProperty = customValueProperties[i];
            applyCustomValue(customValueProperty);
        }

    };

    function getAttributeId() {
        return attributeModelHndl.AttributeId();
    }

    function getProductModel() {
        return pageModelHndl.pProductModel;
    }

    function getAttributeById(productModel, attributeId) {
        var attributes = productModel.Attributes();

        var filtered = attributes.filter(function (item) {
            return item.AttributeId() === attributeId;
        });

        var isEmpty = filtered.length === 0;
        if (isEmpty) {
            return null;
        }

        var lookupAttribute = filtered[0];
        return lookupAttribute;
    }
};
